import SVGS from "../svgs/SVGS"

const InstallPLuginCheck = ({ border, text }) => {
  const { CheckMarkSVG } = SVGS()
  return (
    <div className="install-plugin">
      <CheckMarkSVG/>
      <span className="install-plugin-text">{text}</span>
    </div>
  )
}

export default InstallPLuginCheck
